import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import LoadingButton from '@atlaskit/button/loading-button';
import AkButton from '@atlaskit/button/standard-button';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ContainerDiv = _styled("div", {
  target: "e1izsb6b0",
  label: "ContainerDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "n947sy",
  styles: "height:32px;display:flex;align-items:center;"
} : {
  name: "n947sy",
  styles: "height:32px;display:flex;align-items:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default class TwoClickConfirmButton extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      showConfirm: false
    });
    _defineProperty(this, "showConfirm", () => {
      this.setState({
        showConfirm: true
      });
    });
    _defineProperty(this, "hideConfirm", () => {
      this.setState({
        showConfirm: false
      });
    });
    _defineProperty(this, "renderButton", () => {
      return /*#__PURE__*/_jsx(AkButton, {
        spacing: "compact",
        onClick: this.showConfirm,
        children: this.props.buttonText
      });
    });
    _defineProperty(this, "renderConfirm", () => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          isLoading: this.props.showSpinner,
          isSelected: !this.props.showSpinner,
          onClick: this.props.onClickConfirm,
          spacing: "compact",
          children: this.props.confirmText
        }), /*#__PURE__*/_jsx(AkButton, {
          appearance: "subtle-link",
          isDisabled: this.props.showSpinner,
          spacing: "compact",
          onClick: this.hideConfirm,
          children: this.props.cancelText
        })]
      });
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ContainerDiv, {
      children: this.state.showConfirm ? this.renderConfirm() : this.renderButton()
    });
  }
}
_defineProperty(TwoClickConfirmButton, "defaultProps", {
  cancelText: 'Cancel'
});